import axios from 'axios'
// import QS from 'qs'
import urls from './urls'

// 跨域携带session
axios.defaults.withCredentials = false

const service = axios.create({
  baseURL: urls.baseUrl1, // 向后台请求的接口地址的前缀
  timeout: 115000, // 请求的响应时间
})

// http request 请求拦截器，对请求数据处理，有token值则配置上token值
// service.interceptors.request.use(
//   config => {
//     return config
//   }, error => {
//     console.log(error)
//     return Promise.reject(error)
//   })

service.interceptors.response.use(
  response => {
    const res = response.data;
    if (res.code == 200) {
      console.log(res.code,"code11")
      return Promise.resolve(res)
    } else if(res.code==666){
      console.log(res.code,"code33")
      return Promise.reject(res)
    }else{
      console.log(res.code,"code22")
      return Promise.reject(res)
    }
  },
  error => {
    console.log(res.code,"code44")
    return Promise.reject(error)
  })

export default service


// WEBPACK FOOTER //
// ./src/utile/request1.js